import { getGetNodoPortaleQueryKey, getGetNodoQueryKey, NodoDto, useActionDispositivo } from "@/api";
import Button from "@/elements/Button";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { SmallLoading } from "@/components/Loading";
import { DispositivoAction } from "../..";
import { portaleConfig } from "@/portaliConfig";

export function StartStopResetButtons({ nodo }: { nodo: NodoDto }) {
  const { t } = useTranslation();
  const [sentAction, setSentAction] = useState<DispositivoAction | null>(null);

  const { mutateAsync: setActionAsync, isLoading: actionLoading } =
    useActionDispositivo();

  const queryClient = useQueryClient();

  async function setAction(action: DispositivoAction) {
    try {
      setSentAction(action);
      const response = await setActionAsync({
        id: nodo.id,
        data: { action: action },
      });
      if (response.data?.updated) {
        toast.success(t("dispositivoActions.toast.statoSuccess"));
      } else {
        toast.warn(t("dispositivoActions.toast.statoNoResponse"));
      }
    } catch (e) {
      toast.error(t("dispositivoActions.toast.statoError"));
    } finally {
      setSentAction(null);
      queryClient.invalidateQueries({
        queryKey: getGetNodoPortaleQueryKey(portaleConfig.id, nodo.id),
      });
    }
  }

  const powerStatus =
    !!nodo.dispositivoLastStatus &&
    ["on", "on-manuale", "alarm"].includes(nodo.dispositivoLastStatus);

  const manuale =
    nodo.dispositivoLastStatus === "on-manuale" ||
    nodo.dispositivoLastStatus === "off-manuale";

  return (
    <>
      {powerStatus && manuale && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("stop-manuale").then();
          }}
          startIcon={
            sentAction === "stop-manuale" && <SmallLoading sx={{ mr: 1 }} />
          }
        >
          {t("dispositivoActions.buttons.stopManuale")}
        </Button>
      )}
      {powerStatus && !manuale && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("stop").then();
          }}
          startIcon={sentAction === "stop" && <SmallLoading sx={{ mr: 1 }} />}
        >
          {t("dispositivoActions.buttons.stop")}
        </Button>
      )}
      {!powerStatus && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("start").then();
          }}
          startIcon={sentAction === "start" && <SmallLoading sx={{ mr: 1 }} />}
        >
          {t("dispositivoActions.buttons.start")}
        </Button>
      )}
      {!powerStatus && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("start-manuale").then();
          }}
          startIcon={
            sentAction === "start-manuale" && <SmallLoading sx={{ mr: 1 }} />
          }
        >
          {t("dispositivoActions.buttons.startManuale")}
        </Button>
      )}

      <Button
        size="small"
        variant="contained"
        color={actionLoading ? undefined : "light"}
        disabled={actionLoading}
        onClick={() => {
          setAction("reset").then();
        }}
        startIcon={sentAction === "reset" && <SmallLoading sx={{ mr: 1 }} />}
      >
        {t("azioni.reset")}
      </Button>
    </>
  );
}
